import { ProcessLocationTypeDto } from '@/api/generated';
import { generalErrorTranslation } from '@/assets/locales/generalError/generalError.translation.en.ts';
import {
  ProcessCandidatesListTranslation,
  processCandidatesListTranslation,
} from '@/assets/locales/views/processes/details/list/processCandidatesList.translation.en.ts';
import {
  quickTipsTranslation,
  QuickTipsTranslation,
} from '@/assets/locales/views/processes/details/quickTips/quickTips.translation.en.ts';
import { ProcessTab } from '@/views/processes/details/model/ProcessTabs.model.ts';

export type ProcessDetailsTranslation = {
  buttons: {
    edit: string;
    eRecruiter: string;
    goToProcessList: string;
    hideProcessSummary: string;
    runProcess: string;
    showProcessSummary: string;
    startAnalysis: string;
  };
  configuration: {
    cancel: string;
    description: string;
    edit: string;
    emptyNote: string;
    error: string;
    intakeCall: string;
    save: string;
    title: string;
  };
  errors: {
    message: string;
  };
  extendedAtsIntegrationTooltip: string;
  list: ProcessCandidatesListTranslation;
  locationTypes: Record<ProcessLocationTypeDto, string>;
  owner: {
    label: string;
    readOnly: string;
    unassigned: string;
  };
  quickTips: QuickTipsTranslation;
  tabs: Record<ProcessTab, string>;
  title: string;
};

export const processDetailsTranslation: ProcessDetailsTranslation = {
  buttons: {
    edit: 'Edit',
    eRecruiter: 'eRecruiter',
    goToProcessList: 'Go to process list',
    hideProcessSummary: 'Hide details',
    runProcess: 'Run',
    showProcessSummary: 'Show details',
    startAnalysis: 'Start analysis',
  },
  configuration: {
    cancel: 'Cancel',
    description: 'Process description',
    edit: 'Description & intake call',
    emptyNote: 'No intake call note yet',
    error:
      'Could not save changes. Check whether the process is still awaiting configuration and try again.',
    intakeCall: 'Intake call',
    save: 'Save',
    title: 'Process description and intake call',
  },
  errors: {
    message: generalErrorTranslation.default,
  },
  extendedAtsIntegrationTooltip: 'Extended ATS integration',
  list: processCandidatesListTranslation,
  locationTypes: {
    [ProcessLocationTypeDto.Hybrid]: 'Hybrid',
    [ProcessLocationTypeDto.Office]: 'Office',
    [ProcessLocationTypeDto.Remote]: 'Remote',
  },
  owner: {
    label: 'Owner',
    readOnly: 'This process is read-only. It is owned by {{owner}}.',
    unassigned: 'No owner',
  },
  quickTips: quickTipsTranslation,
  tabs: {
    [ProcessTab.CANDIDATE_LIST]: 'Candidates',
    [ProcessTab.PROCESS_INFORMATION]: 'Process Details',
  },
  title: 'Process details',
};
